import React from 'react'
import { useTranslation } from 'react-i18next'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

const currentYear = new Date().getFullYear()
const yearOptions = Array.from({ length: 6 }, (_, i) => currentYear + i)

type YearMonthFilterProps = {
  year: number | ''
  month: number | ''
  onYearChange: (year: number | '') => void
  onMonthChange: (month: number | '') => void
}

const YearMonthFilter: React.FC<YearMonthFilterProps> = ({
  year,
  month,
  onYearChange,
  onMonthChange,
}) => {
  const { t } = useTranslation('parametros')
  const monthNames = t('yearMonthFilter.months', { returnObjects: true }) as string[]

  return (
    <>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel>{t('yearMonthFilter.year')}</InputLabel>
        <Select
          value={year}
          label={t('yearMonthFilter.year')}
          onChange={e => {
            const v = e.target.value
            const newYear = v === '' ? '' : Number(v)
            onYearChange(newYear)
            if (newYear === '') onMonthChange('')
          }}
        >
          <MenuItem value="">{t('yearMonthFilter.all')}</MenuItem>
          {yearOptions.map(y => (
            <MenuItem key={y} value={y}>
              {y}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 140 }} disabled={year === ''}>
        <InputLabel>{t('yearMonthFilter.month')}</InputLabel>
        <Select
          value={month}
          label={t('yearMonthFilter.month')}
          onChange={e => {
            const v = e.target.value
            onMonthChange(v === '' ? '' : Number(v))
          }}
        >
          <MenuItem value="">{t('yearMonthFilter.all')}</MenuItem>
          {monthNames.map((name, idx) => (
            <MenuItem key={idx + 1} value={idx + 1}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  )
}

export default YearMonthFilter
